import _slicedToArray from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import "@kgsport-cms/common";
export function merge() {
  var Services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var resource = arguments.length > 1 ? arguments[1] : undefined;
  var ServiceBase = /*#__PURE__*/_createClass(function ServiceBase() {
    var _this = this;
    _classCallCheck(this, ServiceBase);
    Object.entries(Services).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        s = _ref2[1];
      return typeof s === "function";
    }).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        k = _ref4[0],
        r = _ref4[1];
      // @ts-ignore
      _this[k] = new r(resource);
    });
  });
  return new ServiceBase();
}